import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { PURCHASE_REQUEST_STATUS_META, PURCHASE_REQUEST_STATUS_PICKER, purchaseRequestStatusLabel } from "@/constants/purchase-request";

interface StatusPickerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  onSubmit: (newStatus: string) => void;
}

export default function StatusPicker({ open, onOpenChange, value, onSubmit }: StatusPickerProps) {
  const [selected, setSelected] = useState<string>(value);

  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setSelected(value); }}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Cambiar estado</DialogTitle>
          <DialogDescription>
            Selecciona el nuevo estado para la solicitud. Se mostrará en el historial.
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="h-80 rounded-md border">
          <div className="p-2">
            {PURCHASE_REQUEST_STATUS_PICKER.map((s, idx) => {
              const meta = PURCHASE_REQUEST_STATUS_META[s];
              const active = selected === s;
              return (
                <div key={s}>
                  <button
                    type="button"
                    onClick={() => setSelected(s)}
                    className={`w-full text-left rounded-md border px-3 py-2 text-sm transition-colors ${
                      active ? "border-primary ring-2 ring-primary/30" : "hover:bg-muted"
                    }`}
                  >
                    <div className="font-medium">{purchaseRequestStatusLabel(s)}</div>
                    {meta?.desc && (
                      <div className="text-xs text-muted-foreground mt-0.5">{meta.desc}</div>
                    )}
                  </button>
                  {idx < PURCHASE_REQUEST_STATUS_PICKER.length - 1 && (
                    <Separator className="my-2" />
                  )}
                </div>
              );
            })}
          </div>
        </ScrollArea>

        <div className="mt-6 flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={() => { onSubmit(selected); onOpenChange(false); }}>Guardar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
